import { faArrowDown } from '@fortawesome/pro-regular-svg-icons/faArrowDown';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ConfirmDialog } from 'components/UI';
import { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from './BulkChangeStatusConfirmDialog.module.scss';

interface BulkChangeStatusConfirmDialogProps {
    open: boolean;
    title?: string;
    appointmentsCount: number;
    currentStatusLabels: Array<string>;
    newStatusLabel: string;
    processing?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const BulkChangeStatusConfirmDialog: FunctionComponent<BulkChangeStatusConfirmDialogProps> = props => {
    const isMobile = useMediaQuery({ query: '(max-width:600px)' });

    const title = props.title ?? 'Change Status';
    const petsLabel = `${props.appointmentsCount} Pet${props.appointmentsCount === 1 ? '' : 's'}`;

    const desktopQuestion = (
        <div className={styles.grid}>
            <span className={styles.headerPets}># Pets</span>
            <span className={styles.headerActual}>Actual</span>
            <span className={styles.headerNew}>New</span>

            <span className={styles.valuePets}>{petsLabel}</span>
            <div className={styles.valuesActual}>
                {props.currentStatusLabels.map(label => (
                    <span
                        key={label}
                        className={styles.value}
                    >
                        {label}
                    </span>
                ))}
            </div>
            <span className={styles.valueNew}>{props.newStatusLabel}</span>

            <FontAwesomeIcon
                icon={faArrowRight}
                className={styles.arrow}
            />
        </div>
    );

    const mobileQuestion = (
        <div className={styles.mobileContent}>
            <h2 className={styles.mobileTitle}>{title}</h2>
            <div className={styles.mobileBody}>
                <div className={styles.petsRow}>
                    <span className={styles.header}># Pets</span>
                    <span className={styles.value}>{petsLabel}</span>
                </div>
                <div className={styles.divider} />
                <div className={styles.statusBlock}>
                    <span className={styles.header}>Actual</span>
                    {props.currentStatusLabels.map(label => (
                        <span
                            key={label}
                            className={styles.value}
                        >
                            {label}
                        </span>
                    ))}
                </div>
                <FontAwesomeIcon
                    icon={faArrowDown}
                    className={styles.arrowDown}
                />
                <div className={styles.statusBlock}>
                    <span className={styles.header}>New</span>
                    <span className={styles.value}>{props.newStatusLabel}</span>
                </div>
            </div>
        </div>
    );

    return (
        <ConfirmDialog
            open={props.open}
            title={isMobile ? undefined : <h2 className={styles.title}>{title}</h2>}
            question={isMobile ? mobileQuestion : desktopQuestion}
            cancelButtonLabel="No"
            confirmButtonLabel="Yes"
            isSuccess
            processing={props.processing}
            onCancel={props.onCancel}
            onConfirm={props.onConfirm}
            zIndex={10300}
            className={styles.dialog}
            elementAlignment={isMobile ? 'left' : undefined}
        />
    );
};

export default BulkChangeStatusConfirmDialog;
